import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentTypeBadgeComponent } from './appointment-type-badge.component';

@NgModule({
	declarations: [AppointmentTypeBadgeComponent],
	imports: [CommonModule, TranslateModule],
	exports: [AppointmentTypeBadgeComponent],
})
export class AppointmentTypeBadgeModule {}
